<app-modal-container
  [title]="'Invite member'"
  [bigSize]="false"
  [spinnerProps]="spinnerProps"
  [buttons]="modalButtons"
  [formGroup]="teamMemberForm"
  [applyActivated]="teamMemberForm.valid"
  (applyButtonClicked)="onApply()"
  (dismissButtonClicked)="onCancel()">

  <div class="!w-[20rem] flex flex-col items-center self-stretch gap-y-[1rem]">

    <!-- Email Field -->
    <app-input
      data-qa="team-member-email"
      class="!w-full"
      formControlName="email"
      [title]="'Email'"
      [required]="true"
      [autocomplete]="'off'"
      [inputID]="'team-member-email'"
      [placeholder]="'email@email.com'"
      [suffixFirstIcon]="teamMemberForm.value.email ? 'close.svg' : undefined"
      (suffixFirstIconEmitter)="resetForm()"
    />

    <!-- Admin Checkbox -->
    <app-checkbox
      data-qa="team-member-admin-checkbox"
      formControlName="isAdmin"
      class="self-start font-3 font-normal"
      [checked]="teamMemberForm.value.isAdmin">
      Admin (can manage users)
    </app-checkbox>
  </div>
</app-modal-container>
